module.exports = __webpack_public_path__ + "static/media/seatedLogo.1b1e507b.png";